import { createPolymorphicComponent as mantineCreatePolymorphicComponent } from '@mantine/core';

export const createPolymorphicComponent = mantineCreatePolymorphicComponent;
